<mat-sidenav-container class="h-100">
  <div fxLayout="row" fxLayoutAlign="center center" class="h-100">
    <div fxFlex="80" fxFlex.gt-sm="30" fxFlex.sm="60" class="mat-elevation-z6">
      <app-content-header
        [icon]="'error'"
        [title]="'404'"
        [hideBreadcrumb]="true"
        [hasBgImage]="true"
        [class]="'pt-4 pb-3'"
      ></app-content-header>
      <div class="p-4 text-center">
        <p class="pt-2">{{ 'NOT_FOUND.HEADER' | translate }}</p>
        <p class="pt-2">{{ 'NOT_FOUND.HEADER_DETAILS' | translate }}</p>
        <div class="mt-3">
          <button
            mat-raised-button
            color="primary"
            class="mat-elevation-z6 mx-1"
            type="button"
            (click)="goHome()"
          >
            {{ 'GENERAL.GO_HOME' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-sidenav-container>
